module.exports = __webpack_public_path__ + "static/media/YesterdayLogoWjote.1b936832.png";